import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  openItemNameOfferId: string | null = null;
  itemNamePopoverLeft = 16;
  itemNamePopoverTop = 16;
  itemNamePopoverMaxWidth = 320;

  constructor() {}

  openItemNamePopover(offer: any, anchorEl?: HTMLElement | null, isHandset: boolean = false): void {
    if (isHandset) {
      const offerId = this.getOfferPopoverId(offer);
      if (!offerId || !this.getUpgradeItemName(offer)) return;

      if (anchorEl && typeof window !== 'undefined') {
        const rect = anchorEl.getBoundingClientRect();
        const viewportPadding = 16;
        const desiredWidth = Math.min(window.innerWidth - viewportPadding * 2, 720);

        this.itemNamePopoverLeft = Math.max(viewportPadding, rect.left);
        this.itemNamePopoverTop = rect.bottom + 8;
        this.itemNamePopoverMaxWidth = Math.max(280, desiredWidth);

        const maxLeft = window.innerWidth - viewportPadding - this.itemNamePopoverMaxWidth;
        this.itemNamePopoverLeft = Math.min(this.itemNamePopoverLeft, Math.max(viewportPadding, maxLeft));
      }

      this.openItemNameOfferId = offerId;
    }
  }

  closeItemNamePopover(offer?: any): void {
    if (!offer) {
      this.openItemNameOfferId = null;
      return;
    }

    const offerId = this.getOfferPopoverId(offer);
    if (this.openItemNameOfferId === offerId) {
      this.openItemNameOfferId = null;
    }
  }

  toggleItemNamePopover(event: Event, offer: any, anchorEl?: HTMLElement | null, isHandset: boolean = false): void {
    const offerId = this.getOfferPopoverId(offer);
    if (!offerId || !this.getUpgradeItemName(offer)) return;

    event.preventDefault();
    event.stopPropagation();

    if (this.openItemNameOfferId === offerId) {
      this.openItemNameOfferId = null;
      return;
    }

    this.openItemNamePopover(offer, anchorEl, isHandset);
  }

  isItemNamePopoverOpen(offer: any): boolean {
    return this.openItemNameOfferId === this.getOfferPopoverId(offer);
  }

  getUpgradeItemName(offer: any): string {
    if (offer.upsell_room_category_name) {
      return offer.upsell_room_category_name;
    } else if (offer.room_category_name) {
      return offer.room_category_name;
    }
    return '';
  }

  getOfferPopoverId(offer: any): string | null {
    return offer?.offer_id || offer?.upsell_room_category_name || offer?.room_category_name || null;
  }
}
